// extracted by mini-css-extract-plugin
module.exports = {"label":"BaseSwitch_label__3cq4L","error":"BaseSwitch_error__8d_xi"};